import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Organisation from "../pages/Organisation";
import User from "../pages/User";
import MasterFile from "../pages/MasterFile";
import MasterData from "../pages/MasterData";
import MasterDataVersionHistory from "../pages/MasterDataVersionHistory";
import Login from "../pages/Login";
import AppLayout from "../components/layout/AppLayout";
import InviteOrgDrawer from "../components/drawer/InviteOrgDrawer";
import OrganisationTable from "../pages/Organisation_Table";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import PublicRoute from "../components/auth/PublicRoute";
import ResetPassword from "../pages/Reset_Password";
import ForgotPassword from "../modules/authentication/Forgot Password/ForgotPassword";
import RolePermission from "../pages/RolePermission";
 
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public routes - redirect authenticated users */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
  path="/forgot-password"
  element={
    <PublicRoute>
      <ForgotPassword />
    </PublicRoute>
  }
/>

      <Route
        path="/login/reset-password/:id/:token"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
     
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                <Route path="/organisation" element={<Organisation />} />
                <Route path="/user" element={<User />} />
                <Route path="/master-file" element={<MasterFile />} />
                <Route path="/master-data" element={<MasterData />} />
                <Route
                  path="/master-data/history"
                  element={<MasterDataVersionHistory />}
                />
                <Route path="/role-permission" element={<RolePermission />} />
                <Route path="/organisation-table" element={<OrganisationTable />} />
                <Route path="/" element={<Navigate to="/organisation" replace />} />
                <Route path="*" element={<Navigate to="/organisation" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};
 
export default AppRoutes;
 
 